import React, { useEffect, useRef, useState } from 'react'
import Button from "../../components/Button/Button"
import { Modal } from "@mui/material"



const ModalComponent = ({
  setHidePopup,
  floatingBtn = false,
  disableCloseFunctionButton,
  disableStyleBtn,
  customOpenModal = false,
  disableBtn = true,
  iconButton,
  buttonTitle,
  modalButtonTitle,
  className,
  children,
  title,
  functionButton,
  buttonClasses,
  buttonType,
  buttonWidth,
  modalWidth = '',
  onClose,
  disabled,
  buttonHover,
  buttonTitleStyle,
  subheader,
  customScroll = false,
  openedModal = false,
  hideCloseButtons = false,
  hideDefaultButtons = false,
  customButton = false,
  customClasses = false,
  isMentions = false,
  triggerCloseModal = false,
  awaitFunctionButton = false,
  functionButtonLoading = false,
}) => {
  const [open, setOpen] = useState(openedModal)
  const [pending, setPending] = useState(false)

  const [heightModalContent, setHeightModalContent] = useState(580)
  const isFirstTriggerCloseRender = useRef(true)

  useEffect(() => {
    setOpen(customOpenModal ? customOpenModal : open)
  }, [customOpenModal])

  buttonType = buttonType || 'button'
  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    if (pending || functionButtonLoading) return
    setOpen(false)
    if (onClose) onClose(false)
  }

  const runFunctionButton = async () => {
    setPending(true)
    try {
      await functionButton()
    } catch (error) {
      setPending(false)
      return
    }
    setPending(false)
    if (!disableCloseFunctionButton) {
      setOpen(false)
      if (onClose) onClose(false)
    }
  }

  useEffect(() => {
    if (isFirstTriggerCloseRender.current) {
      isFirstTriggerCloseRender.current = false
      return
    }
    handleClose()
  }, [triggerCloseModal])
  const adjustHeight = () => {
    const maxHeight = 660
    const currentHeight = window.innerHeight
    if (currentHeight < 879) {
      const newHeight = Math.round((currentHeight / 879) * (maxHeight - 120))
      const finalHeight = Math.min(newHeight, maxHeight)
      setHeightModalContent(finalHeight)
    } else {
      setHeightModalContent(maxHeight)
    }
  }
  window.addEventListener('load', adjustHeight)
  window.addEventListener('resize', adjustHeight)

  return (
    <div className={`${modalWidth}`}>
      {disableBtn && !customButton && <Button disabled={disableStyleBtn} type={buttonType} onClick={handleOpen} classes={buttonClasses}
        width={buttonWidth}
        hover={buttonHover}>
        <p className={`flex ${buttonTitleStyle}`}>{iconButton &&
          <img className="pr-2" src={iconButton} alt="icon" />} {buttonTitle}</p>
      </Button>
      }
      {
        customButton && <button onClick={handleOpen} className={customClasses || ''}>{customButton}</button>
      }
      <Modal
        open={open}
        closeAfterTransition
        onClose={handleClose}
      >
        <div className="flex items-center justify-center h-screen ">
          <div
            className={`bg-surface rounded-2xl flex flex-col justify-between ${modalWidth ? modalWidth : 'min-w-[680px]'} max-h-content ${className ?? ''}`}>
            <div className="px-6 pt-6">
              <div className="mb-6 flex justify-between">
                <div className="flex flex-col">
                  <h4 className="font-sans text-lg-18 text-text-primary">{title}</h4>
                  {subheader}
                </div>

                <div className="flex">
                  {floatingBtn && <div className="mr-2 cursor-pointer" onClick={() => setHidePopup(false)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="41" viewBox="0 0 40 41"
                      fill="none">
                      <path
                        d="M27.0575 21.4967C27.6113 21.4967 28.0603 21.0477 28.0603 20.4939C28.0603 19.9401 27.6114 19.4911 27.0575 19.4911C18.5888 19.5013 22.0344 19.5019 12.9334 19.4916C12.6671 19.4905 12.4114 19.5958 12.223 19.7842C12.0347 19.9725 11.9294 20.2282 11.9305 20.4945C11.9294 20.7608 12.0347 21.0165 12.223 21.2048C12.4113 21.3931 12.667 21.4983 12.9333 21.4972L27.0575 21.4967Z"
                        fill="var(--color-gray-600)" />
                    </svg>
                  </div>}
                  {!hideCloseButtons && <div className="inline-flex justify-center items-center rounded-full cursor-pointer"
                    onClick={handleClose}>
                    <svg width={24} height={25} viewBox="0 0 24 25" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M13.4032 12.4942L17.6976 8.20953C18.0892 7.8179 18.0892 7.18292 17.6976 6.79129C17.306 6.39965 16.671 6.39965 16.2794 6.79129L11.995 11.086L7.71063 6.79129C7.31902 6.39965 6.68409 6.39965 6.29248 6.79129C5.90087 7.18292 5.90087 7.8179 6.29248 8.20953L10.5869 12.4942L6.29248 16.7789C6.10342 16.9665 5.99707 17.2218 5.99707 17.4881C5.99707 17.7544 6.10342 18.0096 6.29248 18.1972C6.48 18.3863 6.73527 18.4926 7.00155 18.4926C7.26784 18.4926 7.52311 18.3863 7.71063 18.1972L11.995 13.9025L16.2794 18.1972C16.4669 18.3863 16.7222 18.4926 16.9885 18.4926C17.2548 18.4926 17.51 18.3863 17.6976 18.1972C17.8866 18.0096 17.993 17.7544 17.993 17.4881C17.993 17.2218 17.8866 16.9665 17.6976 16.7789L13.4032 12.4942Z"
                        fill="var(--color-gray-600)" />
                    </svg>
                  </div>}
                </div>
              </div>
            </div>
            <div className="flex-shrink-0 w-full h-px bg-divider" />
            <div className="px-6 pb-6">
              <div className={`py-6 ${isMentions ? 'overflow-visible' : 'overflow-auto'} ${customScroll ? "custom-scrollbar" : ""}`} style={{ maxHeight: heightModalContent }}>
                {children}
              </div>
            </div>
            {!hideDefaultButtons && <div>
              <div className="flex-shrink-0 w-full h-px bg-divider" />
              <div className={`mt-6 mr-6 mb-6 flex justify-end space-x-4`}>
                {!hideCloseButtons &&
                  <Button onClick={handleClose} type="outlined" size="lg" width="w-[156px]" disabled={pending || functionButtonLoading}>Close</Button>}
                <Button disabled={disabled} loading={pending || functionButtonLoading} onClick={awaitFunctionButton ? runFunctionButton : () => {
                  functionButton()
                  if (!disableCloseFunctionButton) {
                    handleClose()
                  }
                }} width="min-w-[156px]">{modalButtonTitle}</Button>
              </div>
            </div>}

          </div>
        </div>
      </Modal>
    </div>
  )
}

export default ModalComponent
